import React, {Component} from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import OverviewWrapper from './overview/OverviewWrapper'
import Landing from './Landing'
import Help from './help/Help'
import Reference from './help/Reference'
import * as filters from './results/FiltersConfig'
import Checks from './results/Checks'
import Record from './results/Record'
import Login from './Login'
import './Content.css'

class Content extends Component {

    render() {
        return (
            <div className='Content'> 
            <Switch>
                <Route path="/overview" render={(props) => {
                    return <OverviewWrapper showHideNav={this.props.showHideNav} handleModal={this.props.handleModal} 
                                            institutionId={this.props.institutionId} runType={this.props.runType}
                                            handleLogout={this.props.handleLogout} 
                                            handleError={this.props.handleError} token={this.props.token} 
                                            location={props.location.pathname}/>
                }} />
                <Route exact path="/results" render={(props) => {
                        return <Checks showHideNav={this.props.showHideNav} institutionId={this.props.institutionId} 
                                      token={this.props.token} runType={this.props.runType}
                                      handleLogout={this.props.handleLogout} 
                                      handleError={this.props.handleError} location={props.location}
                                      handleModal={this.props.handleModal}
                                      handleDropdown={this.props.handleDropdown}
                                      sortingSelection={filters.ChecksSortingSelection}
                                      fieldSelection={filters.FieldSelection}
                                      errorTypeSelection={filters.ErrorTypeSelection}
                                      errorCodeSelection={filters.ErrorCodeSelection}
                                      severitySelection={filters.SeveritySelection}
                                      enrollmentType={filters.EnrollmentType}
                                      enrollmentStatus={filters.EnrollmentStatus}
                                      attendanceType={filters.AttendanceType}
                                      accountStatus={filters.AccountStatus}
                                      history={props.history}
                                      mobile={this.props.mobile}
                                      />
                }} />
                <Route exact path="/results/:record" render={(props) => {
                        return <Record  showHideNav={this.props.showHideNav} 
                                        institutionId={this.props.institutionId} token={this.props.token}
                                        runType={this.props.runType}
                                        handleLogout={this.props.handleLogout} handleError={this.props.handleError} 
                                        handleModal={this.props.handleModal}
                                        handleDropdown={this.props.handleDropdown}
                                        history={props.history}
                                        location={props.location}
                                        params={props.match.params}
                                        sortingSelection={filters.RecordSortingSelection} 
                                        mobile={props.mobile}/>
                }} />
                <Route exact path="/login" render={(props) => {
                        return <Login handleLogin={this.props.handleLogin} isLoggedIn={this.props.isLoggedIn} search={props.location.search}/>
                }} />
                <Route exact path="/logout" render={(props) => {
                        return <Login handleLogout={this.props.handleLogout} isLoggedIn={this.props.isLoggedIn} search={props.location.search}/>
                }} />
                <Route exact path="/help" render={(props) => <Help helpNavState = {this.props.helpNavState}/>} />
                <Route exact path="/help#" render={(props) => <Help helpNavState = {this.props.helpNavState}/>} />
                <Route exact path="/" render={(props) => <Landing isLoggedIn={this.props.isLoggedIn} token={this.props.token} institutionId={this.props.institutionId} />} />
                <Redirect push to="/" />
            </Switch>
        </div>
        )
    }
}

export default Content



// WEBPACK FOOTER //
// ./src/Content.js